import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSocQueue, fetchSocShifts, fetchOnDutyNow, createSocShift } from '../../services/api/socService';
import { fetchUsers } from '../../services/api/identityService';

export const loadSoc = createAsyncThunk('soc/load', async () => {
  const [queue, shifts, onDuty, users] = await Promise.all([fetchSocQueue(), fetchSocShifts(), fetchOnDutyNow(), fetchUsers()]);
  return { queue, shifts, onDuty, users };
});

export const addSocShift = createAsyncThunk('soc/addShift', async (payload) => {
  await createSocShift(payload);
  const [shifts, onDuty] = await Promise.all([fetchSocShifts(), fetchOnDutyNow()]);
  return { shifts, onDuty };
});

const socSlice = createSlice({
  name: 'soc',
  initialState: { status: 'idle', error: null, queue: [], shifts: [], onDuty: [], users: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSoc.pending, (state) => { state.status = 'loading'; })
      .addCase(loadSoc.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.queue = action.payload.queue;
        state.shifts = action.payload.shifts;
        state.onDuty = action.payload.onDuty;
        state.users = action.payload.users;
      })
      .addCase(loadSoc.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addSocShift.fulfilled, (state, action) => {
        state.shifts = action.payload.shifts;
        state.onDuty = action.payload.onDuty;
      });
  }
});

export default socSlice.reducer;
